// actions
import { dispatchSetPermissions } from '$comp/main/root.action'
import { asyncDelay } from './delay'

console.log('mediaPermission navigator ', navigator)
console.log('mediaPermission navigator.mediaDevices ', navigator.mediaDevices)
console.log(
  'mediaPermission navigator.mediaDevices.getUserMedia ',
  navigator.mediaDevices.getUserMedia,
)
console.log('navigator.permissions ', navigator.permissions)

export default async () => {
  await asyncDelay(5000)
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)
    dispatchSetPermissions({ mic: 'denied' })
  else if (navigator.permissions)
    navigator.permissions
      .query({ name: 'microphone' })
      .then(permissionStatus => {
        console.log('permissionStatus ', permissionStatus)
        dispatchSetPermissions({ mic: permissionStatus.state })

        // eslint-disable-next-line no-param-reassign
        permissionStatus.onchange = () =>
          dispatchSetPermissions({ mic: permissionStatus.state })
      })
      // firefox doesn't support query on microphone
      .catch(e => {
        console.log('mediaPermission error ', e)
        dispatchSetPermissions({ mic: 'prompt' })
      })
  else dispatchSetPermissions({ mic: 'prompt' })
}
